import React, { useEffect, useState } from "react";
import registration from "../../assets/images/registration-img.png";
//import facebook2 from "../../assets/images/facebook-02.svg";
//import instagram2 from "../../assets/images/instagram-02.svg";
//import google2 from "../../assets/images/google-2.svg";
//import rediff from "../../assets/images/rediff.svg";
// import bing from "../../assets/images/bing.svg";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { register } from "../features/authSlice";
//import ReactFacebookLogin from 'react-facebook-login';
//import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
const RegisterModal = ({ setmobileno }) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    country_code: "",
    mobile: "",
    full_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const validateRegister = () => {
    const { email, password, confirm_password } = values;
    const toastId = "validate-register";
    if (!email?.trim()) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter Your Email", { toastId: toastId });
      }
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please Enter Valid Email Address");
      return false;
    }
    if (!password) {
      if (!toast.isActive(toast)) {
        toast.error("Password Field Required", { toastId: toastId });
      }
      return false;
    }
    if (!confirm_password) {
      if (!toast.isActive(toast)) {
        toast.error("Confirm Password Field Required", { toastId: toastId });
      }
      return false;
    }
    if (password.length < 8) {
      if (!toast.isActive(toast)) {
        toast.error("Password must be at least 8 characters long", {
          toastId: toastId,
        });
      }
      return false;
    }
    if (password !== confirm_password) {
      if (!toast.isActive(toast)) {
        toast.error("Confirm Password Not Matched", { toastId: toastId });
      }
      return false;
    }
    return true;
  };
  const resetForm = () => {
    setValues({
      country_code: "",
      mobile: "",
      full_name: "",
      email: "",
      password: "",
      confirm_password: "",
    });
    setShowPassword(false);
    setShowPassword1(false);
    setLoading(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateRegister()) {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/get-user-by-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: values.email }),
        }
      );
      const data = await res.json();
      // console.log(data, "data at register modal");
      if (data.success) {
        // console.log("data.success");
        const otpResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/emails/send-email-otp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ name: values.email, email: values.email }),
          }
        );
        const otpData = await otpResponse.json();
        // console.log(otpData, "data at register modal");
        try {
          if (otpData.success) {
            resetForm();
            toast.success(otpData.message);
            // Get both modals
            dispatch(register({ user: values.email, pass: values.password }));
            const registerModalEl = document.getElementById("register");
            const registerInstance =
              window.bootstrap.Modal.getInstance(registerModalEl);
            registerInstance.hide();
            const otpModalEl = document.querySelector("#verify-otp");
            const otpModal = new window.bootstrap.Modal(otpModalEl);
            otpModal.show();
          } else {
            setLoading(false);
            resetForm();
            toast.error(otpData.message);
          }
        } catch (error) {
          resetForm();
          setLoading(false);
        }
      } else {
        toast.error(data.message);
        setLoading(false);
      }
    }
  };

  const responseGoogle = async (response) => {};

  const responseFacebook = async (response) => {};

  useEffect(() => {
    const registerModal = document.getElementById("register");

    const handleHidden = () => {
      resetForm();
      // If we're on /register path, navigate back to home
      if (location.pathname === "/register") {
        navigate("/");
      }
    };

    registerModal.addEventListener("hidden.bs.modal", handleHidden);
    registerModal.addEventListener("show.bs.modal", resetForm);

    return () => {
      registerModal.removeEventListener("hidden.bs.modal", handleHidden);
      registerModal.removeEventListener("show.bs.modal", resetForm);
    };
  }, [navigate, location.pathname]);
  return (
    <>
      <div
        className="modal fade registration"
        id="register"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="fa fa-times" />
            </button>
            <div className="modal-body">
              <div className="row gx-0">
                <div className="col-lg-6 h-100 d-xl-block d-lg-block d-none">
                  <div className="registration-img">
                    <img
                      src={registration}
                      className="w-100 h-100"
                      alt="registration"
                    />
                    <div className="registration-content">
                      <h3 className="text-white">Register</h3>
                      <p className="text-white">
                        Enter your credentials to log register.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="registration-frm">
                    <h4 className="title d-lg-none d-block">Register</h4>
                    <form onSubmit={handleSubmit}>
                      <div className="registration-bx">
                        <label htmlFor="">Email Address</label>
                        <input
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Email Address"
                          maxLength={50}
                        />
                      </div>
                      <div className="registration-bx">
                        <label htmlFor="">New Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Password"
                          maxLength={50}
                        />
                        <div
                          className="eye-btn"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={` ${
                              showPassword ? "fas fa-eye" : "fas fa-eye-slash"
                              }`}
                          ></i>
                        </div>
                      </div>
                      <div className="registration-bx">
                        <label htmlFor="">Confirm New Password</label>
                        <input
                          type={showPassword1 ? "text" : "password"}
                          name="confirm_password"
                          value={values.confirm_password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter Confirm New Password"
                          maxLength={50}
                        />
                        <span
                          className="eye-btn"
                          onClick={() => setShowPassword1(!showPassword1)}
                        >
                          <i
                            className={` ${
                              showPassword1 ? "fas fa-eye" : "fas fa-eye-slash"
                              }`}
                          ></i>
                        </span>
                      </div>
                      <div className="registration-bx">
                        <div className="form-check ps-0">
                          {/* <input className="form-check-input" type="checkbox" defaultValue="" id="agree2" defaultChecked="" /> */}
                          <label className="form-check-label" htmlFor="agree2">
                            By continuing, you agree to our{" "}
                            <Link
                              to="#"
                              onClick={() =>
                                window.open("/privacypolicy", "_blank")
                              }
                            >
                              privacy policy
                            </Link>{" "}
                            and{" "}
                            <Link
                              to="#"
                              onClick={() =>
                                window.open("/termsconditions", "_blank")
                              }
                            >
                              Terms of service
                            </Link>
                          </label>
                        </div>
                      </div>
                      <div className="registration-bx">
                        <button
                          className="thm-btn dark w-100 rounded-5 p-3 bg-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Get OTP"
                          )}
                        </button>
                      </div>
                      <p className="clr fz-18 text-center mt-4">
                        Already have an account?{" "}
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#login"
                          className="txt-org fw-600"
                        >
                          Login
                        </a>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterModal;
